import { z } from 'zod';

import { HeldPurchaseSchema, StationContextRefSchema } from './purchases.schema.js';
import type {
  CreateHeldPurchaseRequest,
  CreateHeldPurchaseResponse,
  ListHeldPurchasesRequest,
  ListHeldPurchasesResponse,
  ResumeHeldPurchaseRequest,
  ResumeHeldPurchaseResponse,
} from './purchases-held.dto.js';

export const CreateHeldPurchaseRequestSchema: z.ZodType<CreateHeldPurchaseRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  laneId: z.string().trim().min(1).max(64).nullable().optional(),
});

export const CreateHeldPurchaseResponseSchema: z.ZodType<CreateHeldPurchaseResponse> = z.object({
  held: HeldPurchaseSchema,
});

export const ListHeldPurchasesRequestSchema: z.ZodType<ListHeldPurchasesRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
});

export const ListHeldPurchasesResponseSchema: z.ZodType<ListHeldPurchasesResponse> = z.object({
  items: z.array(HeldPurchaseSchema),
  station: StationContextRefSchema,
});

export const ResumeHeldPurchaseRequestSchema: z.ZodType<ResumeHeldPurchaseRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  heldId: z.uuid(),
  force: z.boolean().optional(),
});

export const ResumeHeldPurchaseResponseSchema: z.ZodType<ResumeHeldPurchaseResponse> = z.object({
  held: HeldPurchaseSchema,
});
